import React, { FormEvent, useState } from 'react';
import { styled } from 'styled-components';

import Modal from 'Common/components/Modal';

import { Button, ButtonTheme } from 'Compass/components/styled/Button';
import { StyledInput } from 'Compass/components/styled/Input';

const ImageUrlModal = ({ onSave, close }: {
  onSave: (url: string) => void;
  close: () => void;
}) => {
  const [url, setUrl] = useState('');

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSave(url);
    close();
  };

  return <Modal onClickOutside={close}>
    <Content>
      <Title>Add Image URL</Title>
      <form onSubmit={onSubmit}>
        <FormGroup>
          <Label>Image URL</Label>
          <StyledInput
            type="url"
            value={url}
            onChange={(e) => setUrl(e.currentTarget.value)}
            placeholder="https://example.com/image.jpg"
            autoFocus
          />
        </FormGroup>
      </form>
      <Buttons>
        <Button onClick={close} $theme={ButtonTheme.secondary}>Cancel</Button>
        <Button onClick={onSubmit} disabled={!url}>Add Image</Button>
      </Buttons>
    </Content>
  </Modal>;
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 4px;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #475569;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
  margin-top: 8px;
`;


export default ImageUrlModal;
